  <div class="truck-overview-filter no-field-space">
    <sc-flex >
      <mat-form-field class="grow" appearance="fill">
        <mat-label>{{'Filter' | translate: ['shared.tmc-table.filter', translationService.language]}}</mat-label>
        <input matInput [formControl]="textFilterFormControl" [maxLength]="255">
      </mat-form-field>
    </sc-flex>
  </div>